module.exports = __webpack_public_path__ + "img/DritonDs.ef577cae.png";